<template>
  <scale-labels :segments="scaleLabels" />
</template>

<script>
import ScaleLabels from "@/components/timeline/scale/ScaleLabels.vue";
import { getTimeLine } from "@/utils/time.js";
import { mapState } from "vuex";

// @group Timeline
// Timeline scale labels
export default {
  name: "TimelineScale",
  components: {
    ScaleLabels
  },
  props: {
    /** first label UNIX timestamp */
    start: {
      type: Number,
      required: true
    },
    /** time between labels in seconds */
    timestep: {
      type: Number,
      default: 60
    },
    /** count of labels */
    labelsCount: {
      type: Number,
      default: 18
    }
  },
  computed: {
    ...mapState({
      timezone: state => state.timezone.timezone
    }),
    // @vuese
    // Array of timestamp for timeline labels
    scaleLabelsTimestamps() {
      return [...Array(this.labelsCount).keys()].map(
        i => this.start + this.timestep * i
      );
    },
    // @vuese
    // List of timeline labels
    scaleLabels() {
      const segmentSize = this.timestep;

      return this.scaleLabelsTimestamps.map(ts => ({
        label: getTimeLine(ts, this.timezone),
        size: segmentSize
      }));
    }
  }
};
</script>

<style lang="scss" scoped></style>
